import { useEffect, useState } from "react";
import { toast } from "sonner";
import { GoldDots } from "@/components/Brand";
import { errMsg, formatDate, useApi } from "@/lib/api";
import { Panel } from "@/components/admin/AdminUI";

const AlertCard = ({ a, onStatus }) => (
  <li className="rounded-xl border border-rule p-5" data-testid={`alert-${a.id}`}>
    <div className="flex flex-wrap items-center justify-between gap-3">
      <p className="font-medium text-charcoal min-w-0 break-all">{a.name || "Unnamed"} · <span className="text-ink-soft font-normal">{a.email}</span>{a.mobile && <span className="text-ink-soft font-normal"> · {a.mobile}</span>}</p>
      <select className="field !w-40 !py-2 text-sm" value={a.status} onChange={(e) => onStatus(a.id, e.target.value)} data-testid={`alert-status-${a.id}`}>
        <option value="open">Open</option><option value="contacted">Contacted</option><option value="resolved">Resolved</option>
      </select>
    </div>
    <p className="mt-3 text-sm text-ink-soft">{a.question} · {formatDate(a.created_at, { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" })}</p>
    <p className="mt-2 rounded-xl bg-alabaster p-4 leading-relaxed" data-testid={`alert-text-${a.id}`}>{a.flagged_text}</p>
    <p className="mt-3 text-sm">Their response: <span className="font-medium">{a.user_response === "paused" ? "Paused for now" : a.user_response === "continued" ? "I'm OK, continue" : "No response yet"}</span></p>
  </li>
);

export const AdminSafety = () => {
  const api = useApi();
  const [alerts, setAlerts] = useState(null);
  const [view, setView] = useState("all");
  const load = () => api.get("/admin/alerts").then((r) => setAlerts(r.data));
  useEffect(() => { load(); }, [api]); // eslint-disable-line
  const setStatus = async (id, status) => {
    try { await api.patch(`/admin/alerts/${id}`, { status }); toast.success("Alert updated"); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  if (!alerts) return <div className="py-16 flex justify-center"><GoldDots /></div>;
  const list = view === "all" ? alerts : alerts.filter((a) => !a.user_response && a.status === "open");
  return (
    <Panel title="Safety alerts" sub="Only the words that raised the alert are shown, so you can follow your duty of care. Nothing else from the person's plan is visible here." testId="admin-safety"
      right={<div className="flex gap-2">{[["all", "All alerts"], ["unresponsive", "Not yet responded"]].map(([k, l]) => (
        <button key={k} onClick={() => setView(k)} data-testid={`safety-view-${k}`}
          className={`rounded-full px-4 py-1.5 text-sm border ${view === k ? "bg-charcoal border-charcoal text-alabaster" : "bg-white border-rule text-charcoal"}`}>{l}</button>))}</div>}>
      {list.length ? <ul className="space-y-3" data-testid="admin-alerts">{list.map((a) => <AlertCard key={a.id} a={a} onStatus={setStatus} />)}</ul>
        : <p className="text-ink-soft" data-testid="admin-alerts-empty">{view === "all" ? "No safety alerts." : "Everyone flagged has responded."}</p>}
    </Panel>
  );
};
